import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal } from 'bootstrap';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import ContactForm from './ContactForm';

function AutoShowModal() {

  // const [showModal, setShowModal] = useState(false);


  useEffect(() => {
  //   const timer = setTimeout(() => {
  //     const modalEl = document.getElementById('autoModal');
  //     if (modalEl) {
  //       const modal = new Modal(modalEl, {
  //         keyboard: false,
  //         backdrop: 'static',
  //       });
  //       modal.show();
  //     }
  //   }, 15000); // Show after 15 seconds

  //   return () => clearTimeout(timer); // Clean up on unmount
  // }, []);

  const modalAlreadyShown = sessionStorage.getItem('contactModalShown');

  const formSubmitted = localStorage.getItem('formSubmitted');

  if (!modalAlreadyShown  && formSubmitted !== 'true') {
    const timer = setTimeout(() => {
      const modalEl = document.getElementById('autoModal');
      if (modalEl) {
        const modal = new Modal(modalEl, {
          keyboard: false,
          backdrop: 'static',
        });
        modal.show();
        sessionStorage.setItem('contactModalShown', 'true'); // ✅ Mark as shown
      }
    }, 15000); // Show after 15 seconds

    return () => clearTimeout(timer); // Clean up on unmount
  }
}, []);

  return (
    <div
      className="modal fade"
      id="autoModal"
      tabIndex="-1"
      aria-labelledby="autoModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog cmodal-dialog">
        <div className="modal-content cmodal-content">
          <div className="modal-header">
            {/* <h1 className="modal-title fs-5" id="autoModalLabel">Welcome</h1> */}
           <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className="modal-body cmodal-body">
            <ContactForm/>
          </div>
          {/* <div className="modal-footer">
            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
            <button type="button" className="btn btn-primary">Got it</button>
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default AutoShowModal;
